import {Observable, tap} from 'rxjs';

export function debugOp<T>(text: string, stopWithDebugger = false) {
	return (source: Observable<T>) => {
		return source.pipe(
			tap(data => {
				console.debug(text, data);
				if (stopWithDebugger) debugger;
			}),
		);
	};
}
